import { render, staticRenderFns } from "./HochuCredit988.vue?vue&type=template&id=3b3c78a6&"
import script from "./HochuCredit988.vue?vue&type=script&lang=js&"
export * from "./HochuCredit988.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports